import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AjaxHelper } from '../helper/ajax.helper';
import { BaseResponse } from '../model/base.response';
import { WebConstants } from '../util/web.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GeofenceDetailService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper,
    private httpClient: HttpClient) {
  }

  getAll(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE_DETAIL.FIND_ALL_GEOFENCE_DETAIL);
  }

  addGeofenceDetail(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_DETAIL.ADD_GEOFENCE_DETAIL, payload);
  }

  updateGeofenceDetail(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_DETAIL.UPDATE_GEOFENCE_DETAIL, payload);
  }

  deleteGeofenceDetail(geofenceId: Number): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_DETAIL.DELETE_GEOFENCE_DETAIL + geofenceId, geofenceId);
  }

  GeofenceDetailFindByGeofenceId(geofenceId: Number): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE_DETAIL.FIND_GEOFENCE_DETAIL_BY_GEOFENCE_ID + geofenceId);
  }

  // getGeofenceById(geofenceId: Number): Observable<BaseResponse<any>> {
  //   return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE.FIND_GEOFENCE_BY_ID + geofenceId);
  // }
}
